import React, { useEffect, useState, useRef } from "react"
import useApp from "hooks/useApp"
import styles from "css/SecureKeypad.module.css"
import Native from "library/native"
import Global from 'library/Global';

const SecureKeypad = ({ callback, bioCallback, isE2E, more = false, count = 6, title = "비밀번호를 입력해 주세요.", warn, input, autoClose = true, simple = true, bio = false }) => {
	const gXKModule = new window.XKModule()
	const App = useApp()
	const [pressed, setPressed] = useState(0)
	const mounted = useRef()

	const showSecureKeyBoard = () => {
		
		input = typeof input === "string" ? document.querySelector(`${input}`) : input
		if (!input) {
			input = document.createElement("input")
			input.setAttribute("type", "hidden")
			document.body.appendChild(input)
		}
		gXKModule &&
			gXKModule.initialize({
				name: "login-pad",
				editBox: input,
				keyType: "number",
				maxInputSize: count,
				width: 100,
				position: { top: 10, left: null },
				viewType: "half",
				numberKeyRowCount: 3,
				closeDelay: 0,
				autoKeyResize: true,
				isE2E: typeof isE2E !== "undefined" ? isE2E : App.test ? false : true,
				onlyMobile: true,
				hasPressEffect: false,
				onInputChange: function (newLength) {
					Native.vibrate()
					// Ex. 키패드 입력 길이가 최대 입력 길이가 됐을 때 키패드 닫기
					if (newLength === count && gXKModule.isOpen()) {
						setTimeout(() => {
							console.log({autoClose})
							autoClose && gXKModule.close()
							callback && callback(gXKModule)
							setTimeout(() => {
								console.log(typeof gXKModule)
								gXKModule.isOpen() && gXKModule.refresh()
							}, 300)
						}, 300)
					}
					console.log({newLength})
					mounted.current && setPressed(newLength)
					// setDisabled(newLength !== 6)
					// setSocialLength(newLength)
				},
				onKeypadClose: function () {
					// 키패드가 닫힐 때 실행될 로직 작성
				},
			})

			if(bio && window.localStorage.getItem("useBio") == 'true') {
				setTimeout(()=>{ 				
					bioLogin();
				}, 500);
			}

	}

	useEffect(() => {
		console.log({pressed})
	}, [pressed])

	const bioLogin = () => {
		const useBio = window.localStorage.getItem("useBio")
		if (useBio === "true" || useBio === true) {
			const mbId = window.localStorage.getItem("mbId")
			if (!mbId) {
				App.showAlert("아이디가 없습니다.")
			} else {
				Native.execute("AppManager", "authenticate", result => {
					const json = JSON.parse(result)
					if (json.result === "Success") {
						console.log("bioCallback");
						console.log(bioCallback);
						console.log(callback);
						if (bioCallback) {
							console.log("in bioCallback");
							bioCallback(json)
						} else if (callback) {
							console.log("in callback");
							callback()
						}
					} else {
						let msg
						switch (json.result) {
							case "Not found userid":
								msg = "사용자 아이디가 없습니다."
								break
							// [로그인은 되나 아래와 같은 팝업이 계속 뜬다고 하여 일단 주석하고 결과를 지켜봄. 20230117]
							//case "Failed":
							//	msg = "사용자 인증에 실패했습니다. 최초 등록한 유저와 같은지 확인 바랍니다."
							//	break
							case "NotSupport":
								msg = "생체인증을 지원하지 않습니다."
								break
							case "NotEnrolled":
							case "AnotherUser":
								msg = "생체인증이 등록되지 않았거나 지원하지 않는 기능입니다."
								break
							case "AuthFailed":
								msg = "사용자 인증에 실패하셨습니다."
								break
						}
						if (msg) App.alert(msg)
						console.error(decodeURI(json.result))
					}
				}, {
					userid: mbId,
				})
			}
		} else {
			App.showAlert("생체인증 사용을 허용하지 않았습니다.")
		}
	}

	useEffect(() => {
		mounted.current = true
		setTimeout(() => {
			showSecureKeyBoard()
		}, 10)

		return () => {
			mounted.current = false
			gXKModule.close()
		}
	}, [])

	return (
		<div className={styles.SimpleKeypad}>
			<div className={styles.top}>
				<div className={styles.wrap}>
					<div className={styles.title}>{title}</div>
					<Dots count={count} pressed={pressed} />
					{<div className={styles.warn} dangerouslySetInnerHTML={{ __html: warn }} />}
				</div>
				{more && (
					<div className={styles.moreLinks}>
						{/* { simple && <span className={styles.link} onClick={toResetPassword}>간편 비밀번호 재설정</span> } */}
						{bio && (window.localStorage.getItem('useBio') == 'true') && (
							<span className={styles.link} onClick={bioLogin}>
								생체인증 로그인
							</span>
						)}
					</div>
				)}
			</div>
		</div>
	)
}

const Dots = ({ count, pressed }) => {
	return (
		<div className={styles.dots}>
			{[...Array(count)].map((item, idx) => (
				<div key={idx} className={idx < pressed ? styles.on : undefined}></div>
			))}
		</div>
	)
}

export default SecureKeypad
